import React, { Component } from 'react';
import Logger from './logger';

const IS_DEV = process.env.NODE_ENV !== 'production';

/**
 * ErrorModal
 * Self-contained crash fallback UI. Intentionally avoids any dependency that
 * might itself be broken (Redux, Router, etc.).
 *
 * Props:
 *   error    {Error}    – the caught error object
 *   onRetry  {Function} – callback to reset the ErrorBoundary state
 *   tripped  {boolean}  – true when the circuit-breaker has fired
 */
export default class ErrorModal extends Component {
  constructor(props) {
    super(props);
    this.state = { stackOpen: false };
    this.toggleStack   = this.toggleStack.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
  }

  toggleStack() {
    this.setState(s => ({ stackOpen: !s.stackOpen }));
  }

  handleDownload() {
    Logger.downloadLogs();
  }

  render() {
    const { error, onRetry, tripped } = this.props;
    const { stackOpen } = this.state;

    if (tripped) {
      return (
        <div className="gl-error-unavailable">
          <div className="gl-error-unavailable__box">
            <span className="gl-error-unavailable__icon" aria-hidden="true">⚠</span>
            <h2 className="gl-error-unavailable__title">Sistema Indisponível</h2>
            <p className="gl-error-unavailable__body">
              Ocorreram múltiplos erros consecutivos. Por favor recarregue a página ou contacte o suporte.
            </p>
            <div className="gl-error-unavailable__actions">
              <button
                className="gl-button primary medium"
                onClick={() => window.location.reload()}
              >
                Recarregar página
              </button>
              <button
                className="gl-button secondary medium"
                onClick={this.handleDownload}
              >
                Descarregar logs
              </button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="gl-error-modal__overlay">
        <div className="gl-error-modal__box" role="alertdialog" aria-modal="true">
          <span className="gl-error-modal__icon" aria-hidden="true">⚠</span>
          <h2 className="gl-error-modal__title">Algo correu mal</h2>
          <p className="gl-error-modal__body">
            Ocorreu um erro inesperado nesta secção. Pode tentar novamente ou descarregar
            os logs de diagnóstico para partilhar com o suporte.
          </p>

          {IS_DEV && error && (
            <div className="gl-error-modal__debug">
              <button
                className="gl-error-modal__debug-toggle"
                onClick={this.toggleStack}
                aria-expanded={stackOpen}
              >
                {stackOpen ? '▲ Ocultar detalhes' : '▼ Mostrar detalhes técnicos'}
              </button>
              {stackOpen && (
                <pre className="gl-error-modal__stack">
                  {error.stack || error.message}
                </pre>
              )}
            </div>
          )}

          <div className="gl-error-modal__actions">
            <button
              className="gl-button primary medium"
              onClick={onRetry}
            >
              Tentar novamente
            </button>
            <button
              className="gl-button secondary medium"
              onClick={this.handleDownload}
            >
              Descarregar logs
            </button>
          </div>
        </div>
      </div>
    );
  }
}
